<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      碧海湾站<br>
站点介绍<br>
碧海湾站位于碧海中心区宝源路与金海路交叉处，主体位于宝源路，大致呈西南走向，沿宝源路设置。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:00	00:07	11号线	4分钟	6分32秒<br>
碧头	06:27	23:59	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:00	00:07	11号线	4分34秒	6分钟<br>
碧头	06:27	23:59	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:00	00:07	11号线	4分37秒	6分钟<br>
碧头	06:27	23:59	11号线	4分37秒	6分钟<br><br>

站点出口信息<br<br>>
A出入口:<br>
宝源路南侧（西）、银田路西侧、松茂御龙湾、深圳恒生医院、华丰前海湾、碧海君庭、正中华丽中心<br><br>
B出入口:<br>
宝源路南侧(东)、海港小学、泰华阳光海、中信湾上六座花园<br><br>
C出入口:<br>
宝源路北侧、碧海湾花园、海湾明珠花园、中熙香缇湾花园<br><br>
D出入口:<br>
金海路、宝源路北侧（西）、西湾小学、深圳市海湾中学<br><br>
E出入口:<br>
西乡体育中心、锦明花园、锦欣花园、宝源路北侧<br><br>
公交换乘信息<br><br>
2号出入口:<br>
公交站名： 大运地铁站①<br>
351、M322、M266、M314、E34、M239、358、M396、833、M294、E33、M22、M466、E23、923<br><br>
10B出入口:<br>
公交站名： 大运地铁站②<br>
M359、M360、M547、M546、M368<br><br>
10A出入口:<br>
公交站名： 大运地铁站③<br>
M219、,357、M303<br><br>
14号出入口:<br>
公交站名： 大运地铁站<br>
E33、M357、M547、923、M360、M359、358、M229、351、M396、M266、M239、833、M466、M314、E23、M368<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>